import { createAction, props } from '@ngrx/store';

export const cambiarInventario = createAction(
  '[Inventarios] Cambiar Inventario',
  props<{ objConPropiedadesParaAsignar: Object }>()
);

export type AccionesValidas = ReturnType<typeof cambiarInventario>;
